var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRetroStyle4 = function SvgRetroStyle4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 227,
    viewBox: "0 0 132 227",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_403",
    x: 17,
    y: 73,
    width: 101,
    height: 23,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", null), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_404",
    x: 17,
    y: 46,
    width: 101,
    height: 23,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", null), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_405",
    x: 33,
    y: 104,
    width: 69,
    height: 105,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", null), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "retro-style-4",
    transform: "translate(-3573 -1397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_402",
    "data-name": "Rectangle 402",
    transform: "translate(3573 1397)",
    fill: "#c7a8f7",
    stroke: "#33475b",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 227,
    rx: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 130,
    height: 225,
    rx: 10,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3573, 1397)",
    filter: "url(#Rectangle_403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_403-2",
    "data-name": "Rectangle 403",
    transform: "translate(17 73)",
    fill: "#ffcc1e",
    stroke: "#170c05",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 98,
    height: 20,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3573, 1397)",
    filter: "url(#Rectangle_404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_404-2",
    "data-name": "Rectangle 404",
    transform: "translate(17 46)",
    fill: "#ffcc1e",
    stroke: "#170c05",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 98,
    height: 20,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Link",
    transform: "translate(3632 1458)",
    fill: "#170c05",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Link")), /*#__PURE__*/React.createElement("text", {
    id: "Link-2",
    "data-name": "Link",
    transform: "translate(3632 1483)",
    fill: "#170c05",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Link")), /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(3819 1260)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -246, 137)",
    filter: "url(#Rectangle_405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_405-2",
    "data-name": "Rectangle 405",
    transform: "translate(33 104)",
    fill: "#fff",
    stroke: "#170c05",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 103,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 66,
    height: 102,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_406",
    "data-name": "Rectangle 406",
    transform: "translate(-210 326)",
    fill: "#ffcc1e",
    stroke: "#170c05",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 60,
    height: 12,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_407",
    "data-name": "Rectangle 407",
    transform: "translate(-206 247)",
    fill: "#fff",
    stroke: "#170c05",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 37,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 53,
    height: 36,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Follow_My_Insta",
    "data-name": "Follow My Insta",
    transform: "translate(-201 296)",
    fill: "#170c05",
    fontSize: 6,
    fontFamily: "SegoeUI-SemiBold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Follow My Insta")), /*#__PURE__*/React.createElement("text", {
    id: "Description",
    transform: "translate(-207 304)",
    fill: "#170c05",
    fontSize: 4,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 17.458,
    y: 4
  }, "Description")), /*#__PURE__*/React.createElement("text", {
    id: "Link-3",
    "data-name": "Link",
    transform: "translate(-179 334)",
    fontSize: 6,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.328,
    y: 0
  }, "Link"))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(3625 1407)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRetroStyle4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/retro-style-4.374efd1e.svg";
export { ForwardRef as ReactComponent };